import { randoms } from "lib/utils"




export default function useLayoutBuilder(
  workingLayout:any, 
  setWorkingLayout:any,
  selectedElement:any,
  setSelectedElement:any
){

  const addToLayout = (type:string, insertSeq?:number) => {
    const newBlock = { 
      refstr: randoms.string(12, "a#"), 
      type: type, 
      level: 1, 
      parent: null, 
      height: (type === "hstack") ? "sm" : type === "vstack" ? "lg" : "xs",
      seq: insertSeq || workingLayout.config.structure.filter((item:any) => item.parent === null).length + 1,
      split: type === "element" ? undefined : type === "hstack" ? [50, 50] : [100,100]
    }
    console.log(newBlock.refstr)
    setWorkingLayout((prev:any) => {
      if( prev.config.structure.find( (item:any) => item.refstr === newBlock.refstr ) ){
        return prev
      }
      const currStructure = prev.config.structure || []
      currStructure.splice(insertSeq, 0, newBlock).map( (item:any, index:number) => ({...item, seq: index + 1 }))
      return {
        ...prev, 
        config: {
          ...prev.config,
          structure: currStructure
        }
      }
    })
  }


  const moveInLayout = (draggedRefstr:string, targetRefstr:string) => {
    setWorkingLayout((prev:any) => {
      const currStructure = prev.config.structure || []
      const draggedItem = currStructure.find((item:any) => item.refstr === draggedRefstr)
      const targetItem = currStructure.find((item:any) => item.refstr === targetRefstr)
      if( draggedItem && targetItem ){
        const newStructure = currStructure.map((item:any) => {
          if( item.refstr === draggedRefstr ){
            return { ...item, seq: targetItem.seq }
          } else if( item.refstr === targetRefstr ){
            return { ...item, seq: draggedItem.seq }
          }
          return item
        })
        return {
          ...prev,
          config: {
            ...prev.config,
            structure: newStructure
          }
        }
      }
      return prev
    })
  }

  const assignElement = ({ component, title, showTitle }:any) => {
    console.log(selectedElement)
    if( !component ) return null
    setWorkingLayout( (prev:any) => ({
      ...prev,
      config: {
        ...prev.config,
        structure: prev.config.structure.map((item:any) => {
          if (item.refstr === selectedElement) {
            return { ...item, refstr: component, showTitle, title: showTitle ? title : null } 
          }
          return item
        })
      }
    }))
  }

  const deleteFromLayout = (refstr:string) => {
    console.log(refstr)
    setWorkingLayout((prev:any) => {
      const currStructure = prev.config.structure || []
      const newStructure = currStructure.filter((item:any) => item.refstr !== refstr)
      return {
        ...prev, 
        config: {
          ...prev.config,
          structure: newStructure.map( (item:any, index:number) => ({...item, seq: index + 1 }))
        }
      }
    })
  }


  const saveLayout = async() => {
    if( !workingLayout?._id ) return null
    const result = await fetch(
      `/api/layout/${workingLayout._id}`, 
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(workingLayout)
      }
    )
    console.log(result)
  }


  const layoutBldrTools:any = {
    addToLayout,
    assignElement,
    deleteFromLayout,
    moveInLayout,
    saveLayout
  }

  return {
    layoutBldrTools
  }

}